export default __webpack_public_path__ + "static/media/screen-img.991b83f0.png";